import { createContext, ReactNode, useMemo, useReducer } from 'react';
import { SmartSendProvider } from '~/lib/consts/providers';
import { DefaultSummary } from '../helpers/SmartSendFilterApplier';
import { DefaultFilter } from '../helpers/DefaultFilter';
import { IAppContextAction } from './BaseContextModels';
import { ISmartSendContext } from './SmartSendContextModels';
import SmartSendContextReducer from './SmartSendContextReducer';
import { GetDefaultVatStatus } from '../../components/smartsend/quotes/utils/GetVatStatuses';
import { SmartSendSubType } from '../consts/SmartSendSubType';

const initialState: ISmartSendContext = {
  customer: {
    CountryIsoCode: 'GBR',
    Meta: {},
    Provider: SmartSendProvider,
    VatNumber: '',
    VatStatus: GetDefaultVatStatus('Sender')
  },
  returnCustomer: {
    CountryIsoCode: 'GBR',
    Meta: {},
    Provider: SmartSendProvider,
    VatNumber: '',
    VatStatus: GetDefaultVatStatus('Sender')
  },
  filters: {
    [SmartSendSubType]: {
      filter: DefaultFilter(),
      summary: DefaultSummary()
    }
  }
};

const SmartSendContext = createContext<{
  state: typeof initialState;
  dispatch: (action: IAppContextAction) => void;
}>({ state: initialState, dispatch: () => {} });

const SmartSendContextProvider: React.FC<{ children: ReactNode }> = (props) => {
  const [state, dispatch] = useReducer(SmartSendContextReducer, { ...initialState });
  const value = useMemo(() => ({ state, dispatch }), [state]);
  return <SmartSendContext.Provider value={value}>{props.children}</SmartSendContext.Provider>;
};

const SmartSendContextConsumer = SmartSendContext.Consumer;

export { SmartSendContext, SmartSendContextProvider, SmartSendContextConsumer };
